import dayjs from "dayjs"

export const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
export const currentYear = currentDate.getFullYear()
export const currentFinancialYearStart = new Date(currentYear, 3, 1)

export let currentFinancialYear = {
    fromDate: dayjs(),
    toDate: dayjs()
}

export let previousFinancialYear = {
    fromDate: dayjs(),
    toDate: dayjs()
}

if (currentDate.getTime() >= currentFinancialYearStart.getTime()) {
    currentFinancialYear = {
        fromDate: dayjs(currentFinancialYearStart),
        toDate: dayjs(currentDate)
    }

    previousFinancialYear = {
        fromDate: dayjs(new Date(currentYear - 1, 3, 1)),
        toDate: dayjs(new Date(currentYear, 2, 31))
    }
} else {
    currentFinancialYear = {
        fromDate: dayjs(new Date(currentYear - 1, 3, 1)),
        toDate: dayjs(currentDate)
    }

    previousFinancialYear = {
        fromDate: dayjs(new Date(currentYear - 2, 3, 1)),
        toDate: dayjs(new Date(currentYear - 1, 2, 31))
    }
}

export interface Values {
    frequency: string;
    fromDate: dayjs.Dayjs;
    toDate: dayjs.Dayjs;
}

export const statementTitleMap: Record<string, string> = {
    detailedAccountStmt: "Consolidated Detailed Account Statement",
    capitalGainsStmt: "Consolidated Capital Gains Statement"
}